import type {
	CreateReminderRequestDTO,
	UpdateReminderRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { formatApiDate } from "web_myplann/Shared/Utils/apiDate";

type MapperConfig = Pick<ReminderEntityConfig, "showName">;

const getTitle = (model: ReminderFormModel, config?: MapperConfig) =>
	(config?.showName ?? true) && model.name ? { title: model.name } : {};

export const mapReminderFormToCreateRequest = (
	model: ReminderFormModel,
	config?: MapperConfig,
): CreateReminderRequestDTO => ({
	typeKey: model.typeKey,
	date: formatApiDate(model.date),
	recurrence: model.recurrence,
	...getTitle(model, config),
});

export const mapReminderFormToUpdateRequest = (
	model: ReminderFormModel,
	config?: MapperConfig,
): UpdateReminderRequestDTO => ({
	typeKey: model.typeKey,
	date: formatApiDate(model.date),
	recurrence: model.recurrence,
	...getTitle(model, config),
});
